import Component from '../app/component'
import ImagesParallax from '../plugins/images-parallax.js'
import gsap from 'gsap'
import { tns } from 'tiny-slider';

export default class HomeComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {

    let slider = document.querySelector('.cm-home__slider');
    // console.log(slider);
    if(slider) {
      let homeslider = tns({
        container: '.cm-home__stage',
        items: 1,
        loop: true,
        nav: false,
        autoplay: true,
        autoplayTimeout: 5000,
        speed: 1500,
        mouseDrag: true,
        controls: true,
        controlsContainer: '.cm-home__slider__controls',
      })
    }



    new ImagesParallax(this.refs.images)

    const loaderIgnore = sessionStorage.getItem('loaderIgnore')
    if (loaderIgnore) {
      this.el.classList.add('cm-home--active')
      this.tweenIn()
    } else {
      document.addEventListener('loader.end', () => {
        this.el.classList.add('cm-home--active')
        this.tweenIn()
      })
    }
  }

  async tweenIn () {
    const tl = gsap.timeline()

    const images = []
    if (this.refs?.imagesWrappers?.[0]) {
      images.push(this.refs.imagesWrappers[0])
    }
    if (this.refs?.imagesWrappers?.[1]) {
      images.push(this.refs.imagesWrappers[1])
    }
    if (this.refs?.imagesWrappers?.[2]) {
      images.push(this.refs.imagesWrappers[2])
    }

    tl.fromTo(
      images,
      {
        opacity: 0,
        yPercent: 100
      },
      {
        opacity: 1,
        yPercent: 0,
        duration: 1.25,
        ease: 'power3.inOut',
        stagger: 0.1,
        clearProps: 'all'
      },
      0
    )

    return tl.then()
  }
}
